import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { HelpCircle, MessageCircle } from "lucide-react";

export default function FAQ({ items = [], settings, profileEmail }) {
    if (items.length === 0) return null;

    const waNumber = String(settings?.whatsapp_number || "").replace(/\D/g, "");
    const waLink = waNumber
        ? `https://wa.me/${waNumber}?text=${encodeURIComponent("Halo Akhmad, saya ada pertanyaan tentang layanan Anda.")}`
        : null;

    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative py-24 md:py-32 border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
                    <div className="lg:col-span-4 lg:sticky lg:top-32 lg:self-start">
                        <div className="mono-label mb-4 flex items-center gap-2">
                            <HelpCircle size={11} className="text-brand" /> 07 · Questions
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tighter">
                            Frequently <span className="text-brand">asked</span>.
                        </h2>
                        <p className="mt-6 text-ink-200">
                            Direct answers to common technical, workflow, and engagement inquiries. Have another question?
                        </p>
                        <div className="mt-6 flex flex-wrap gap-3">
                            {waLink && (
                                <a
                                    href={waLink}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="faq-whatsapp-cta"
                                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-medium transition-colors"
                                >
                                    <MessageCircle size={14} /> Ask on WhatsApp
                                </a>
                            )}
                            {profileEmail && (
                                <a
                                    href={`mailto:${profileEmail}`}
                                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/15 text-white text-sm hover:bg-white/5 transition-colors"
                                >
                                    Email me
                                </a>
                            )}
                        </div>
                    </div>

                    <div className="lg:col-span-8">
                        <Accordion type="single" collapsible defaultValue={items[0]?.id} className="space-y-3">
                            {items.map((q) => (
                                <AccordionItem
                                    key={q.id}
                                    value={q.id}
                                    data-testid={`faq-item-${q.id}`}
                                    className="rounded-xl border border-white/5 bg-ink-800/40 px-6 data-[state=open]:border-brand/30 data-[state=open]:bg-ink-800/60"
                                >
                                    <AccordionTrigger className="text-left text-white hover:no-underline font-display text-lg sm:text-xl tracking-tight py-5">
                                        {q.question}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-ink-100 leading-relaxed text-base pb-5">
                                        {q.answer}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
}
